import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { getSmsUsage } from 'api/admin/smsUsage/smsUsage';
import { ApiError } from 'types/api';
import { DailySmsUsageResponse } from 'types/smsUsage/smsUsage';

export const SMS_USAGE_QUERY_KEY = 'smsUsage';

export const useSmsUsage = (date: string) => {
  return useQuery<unknown, ApiError, DailySmsUsageResponse>({
    queryKey: [SMS_USAGE_QUERY_KEY, { date }],
    queryFn: async () => {
      const { data } = await getSmsUsage(date);
      return data;
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(error?.response?.data?.error ?? 'An error occurred while fetching SMS usage', {
        duration: 4000,
      });
    },
  });
};
